import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []

  redirect() {
    window.location.href = this.element.value 
  }
}
